import { Box, Card, Heading, Text, VStack } from '@chakra-ui/react';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Clock } from 'iconoir-react';

interface ProcessingStateProps {
  webhookTimeout: boolean;
  payoutStatus?: string;
}

export const ProcessingState: React.FC<ProcessingStateProps> = ({
  webhookTimeout,
  payoutStatus,
}) => {
  const { t } = useTranslation();

  return (
    <VStack gap={6} align="stretch">
      <Card.Root rounded="xl">
        <Card.Body>
          <VStack gap={4} py={8}>
            <Box
              animation="spin 2s linear infinite"
              css={{
                '@keyframes spin': {
                  from: { transform: 'rotate(0deg)' },
                  to: { transform: 'rotate(360deg)' },
                },
              }}
            >
              <Clock width={48} height={48} color="var(--chakra-colors-primary-500)" />
            </Box>
            <VStack gap={2} textAlign="center">
              <Heading size="lg">{t('payouts.confirmation.processing.title')}</Heading>
              <Text color="gray.600" animation="pulse 1.5s ease-in-out infinite">
                {webhookTimeout
                  ? t('payouts.confirmation.processing.timeoutMessage')
                  : payoutStatus === 'draft'
                    ? t('payouts.confirmation.processing.draftMessage')
                    : t('payouts.confirmation.processing.processingMessage')}
              </Text>
              {webhookTimeout && (
                <Text fontSize="sm" color="gray.500" mt={2}>
                  {t('payouts.confirmation.processing.timeoutNote')}
                </Text>
              )}
            </VStack>
          </VStack>
        </Card.Body>
      </Card.Root>
    </VStack>
  );
};
